import MicroModal from 'micromodal';

export default class HandelModal {

    static init() {
        MicroModal.init({
            awaitCloseAnimation: true
        });
        const triggers = document.querySelectorAll('[data-micromodal-trigger]');
        if (triggers.length > 0) {
            triggers.forEach( trigger => {
                trigger.setAttribute('micromodal-init', 'true');
            })
        }
    }

    static bindNewModals() {
        const triggers = document.querySelectorAll('[data-micromodal-trigger]');
        if (triggers.length > 0) {
            triggers.forEach( trigger => {
                let wasInit = trigger.getAttribute('micromodal-init');
                if (!wasInit) {
                    let modalID = trigger.getAttribute('data-micromodal-trigger');
                    trigger.addEventListener('click', e => {
                       e.preventDefault();
                       MicroModal.show(modalID,{
                           awaitCloseAnimation: true
                       });
                    });
                    trigger.setAttribute('micromodal-init', 'true');
                }
            })
        }
    }

    static a11y() {
        const triggers = document.querySelectorAll('.jsWatchA11y');
        const modal = document.getElementById('watchProductA11y');
        if (triggers.length > 0 && modal) {
            triggers.forEach( trigger => {
                trigger.addEventListener('click', e => {
                   e.preventDefault();
                   let stock = trigger.dataset.stock;
                   if (stock) {
                       const checkbox = document.getElementById('watchProductA11yCheckbox');
                       const checkboxInput = checkbox.querySelector('input');
                       if (stock === 'true') {
                           if (checkboxInput.checked === false) {
                               checkbox.click();
                           }
                       } else {
                           if (checkboxInput.checked) {
                               checkbox.click();
                           }
                       }
                   }
                   MicroModal.show('watchProductA11y', {
                       awaitCloseAnimation: true
                   });
                });
            });
        }
    }
}